import Config from 'config';

const useConfig = () => {
    return {
        ...Config,
    };
};

export default useConfig;
